import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Booking } from '../../interfaces/booking';
import { DbService } from '../../services/db.service'
import { Subscription } from 'rxjs'
import * as uuid from 'uuid/v1'
import * as moment from 'moment'

declare var encode: Function

@Component({
  selector: 'app-cancel',
  templateUrl: './cancel.component.html',
  styleUrls: ['./cancel.component.css']
})
export class CancelComponent implements OnInit {

  debug = false
  steg = 0
  booking: Booking = <Booking>{}
  settings = []
  resources = []
  confirmations = []
  subscription: Subscription
  routeSubscription
  cancelId = ''
  logo = ''
  avbKarens = 48
  dismiss = 'about:blank'

  constructor(public db: DbService, private route: ActivatedRoute) { }

  ngOnInit() {

    this.subscription = this.db.getMessages().subscribe(message => {
      this.messageHandler(message)
    })

    this.routeSubscription = this.route.params.subscribe(params => {
      //console.log(params);
      this.cancelId = params.id
      this.db.system = params.system
      this.db.bg = "https://cdn.bokad.se/" + params.system + "/bg.jpg"
      //this.getBooking(params.uuid);
    })

    this.db.sendMessage('login', { system: this.db.system, user: 'web', pass: '' })

  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
    this.routeSubscription.unsubscribe()
  }

  messageHandler(message) {

    if (message.action == 'login') { 

      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'settings', 
        condition: { system: this.db.system, name: { $regex: '^web', $options: 'i'} },
        tableSuffix: '' ,
        sort: {},
        limit: 0
      })

    }

    if (message.table == 'settings') {

      this.settings = <any[]>message.data

      // Get karens
      this.settings.filter(s => s.name == 'webavbkarens').forEach(s => {
        this.avbKarens = +s.value
      })   

      // Get dismiss address
      this.settings.filter(s => s.name == 'webreturn').forEach(s => {
        this.dismiss = s.value
      })   
      
      // Get logo
      this.settings.filter(s => s.name == 'weblogo').forEach(s => {
        if (s.value.length > 4) {
          this.db.sendMessage('dbm', { 
            cmd: 'find', 
            table: 'files', 
            condition: { system: this.db.system, name: s.value },
            tableSuffix: '' ,
            sort: {},
            limit: 1
          })
        }
      })      
      
      // Get resources
      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'resources', 
        condition: { system: this.db.system },
        tableSuffix: '' ,
        sort: {},
        limit: 0
      })

      // Get confirmations
      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'confirmations', 
        condition: { system: this.db.system, type: { $in: [2, 3] } },
        tableSuffix: '' ,
        sort: {},
        limit: 0
      })      

    } 
    
    if (message.table == 'resources') {

      this.resources = <any[]>message.data

      // Get booking
      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'bookings', 
        condition: { system: this.db.system, id: this.cancelId, deleted: false },
        tableSuffix: '' ,
        sort: {},
        limit: 0
      })      

    }

    if (message.table == 'confirmations') {
      this.confirmations = <any[]>message.data
    }

    if (message.table == 'files') {
      
      var files = <any[]>message.data
      if (files.length == 1) this.logo = files[0].data
    }

    if (message.table == 'bookings') {
      
      if (message.data.length == 1) {

        this.booking = message.data[0]
        this.steg = 1

        var time = 9999
        this.booking.collapsedItems.forEach(ci => {
          if (ci.start < time) time = ci.start
        })

        // Check Karens
        
        var hours = moment.duration(moment(this.booking.workday + ' ' + this.db.minToTime(time) + ':00').diff(moment())).asHours()
        
        //console.log('Diff', hours)

        if (hours < this.avbKarens) {
          this.steg = 10
          this.suicide()
        }

      } else {
        this.steg = 9
      }

    }

  }

  getResource(id) {
    
    var ret = ''
    
    this.resources.filter(r => r.id == id).forEach(r => {
      ret = r.name 
    })

    if (this.db.system.toLowerCase() == 'cioccolata') ret = 'Restaurang'

    return ret

  }

  getAntal(ci) {

    var ret = ''

    this.resources.filter(r => r.id == ci.idResource).forEach(r => {

      if (+r.confirmationtype == 1 && ci.bookingObjects.length > 0) {
        ret = ci.bookingObjects.length + ' ' + ( ci.bookingObjects.length == 1 ? r.unit : r.unitplural)
      }

      if (+r.confirmationtype == 2 && this.booking.persons > 0) {
        ret = this.booking.persons + ' ' + ( this.booking.persons == 1 ? 'person' : 'personer')
      }

    })

    return ret

  }


  avboka() {
    this.steg = 2
  }

  ardusaker() {

    this.steg = 3
    
    this.booking.deleted = true
    this.booking.signature = "Web"

    // Mail Confirmation
    this.confirmations.filter(c => c.type == 2).forEach(confirmation => {

      var mailObj = {
        cmd: 'sendmail',
        subject: confirmation.subject,
        to: this.booking.contact.epost,
        message: this.messageReplace(confirmation.message),
        system: this.db.system,
        id: this.booking.id
      }

      var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)

      if (regexp.test(this.booking.contact.epost)) this.db.sendMessage('send', mailObj)
  
    })


    // SMS Confirmation
    this.confirmations.filter(c => c.type == 3).forEach(confirmation => {

      var mobil = this.fixMobile(this.booking.contact.mobil)

      var smsObj = {
        cmd: 'sendsms',
        sender: confirmation.subject,
        to: mobil,
        message: this.messageReplace(confirmation.message),
        system: this.db.system,
        id: this.booking.id
      }

      if (mobil.length == 12) this.db.sendMessage('send', smsObj)
  
    })

    // Create bookingevent
    this.createBookingEvent('Avbokning Web')

    // Save booking
    let cmd = { 
      cmd: 'save',
      system: this.db.system,
      table: 'bookings',
      id: this.booking.id,
      user: 'Web',
      data: this.booking,
      token: this.db.token
    }
    encode(cmd)
    this.db.sendMessage('db', JSON.stringify(cmd))

    // Dismiss user
    this.suicide()

  }
  
  messageReplace(s) {
    return s
      .replace('{fnamn}', this.booking.contact.fnamn)
      .replace('{enamn}', this.booking.contact.enamn)
      .replace('{epost}', this.booking.contact.epost)
      .replace('{mobil}', this.booking.contact.mobil)
      .replace('{datum}', this.booking.workday)
  }

  fixMobile(nr) {
    nr = nr.replace(" ", "");
    nr = nr.replace("-", "");
    if (nr.substring(0, 1) == "0") nr = nr.substring(1);
    let cc = '+46'
    if (this.db.system == 'bbz') cc = '+41'
    if (nr.substring(0, 2) != "+4") nr = cc + nr;
    return nr;
  }

  createBookingEvent(eventText) {
    
    var eventId = uuid()
    var now = new Date()

    this.db.sendMessage('dbm', { 
      cmd: 'save', 
      table: 'bookingevents', 
      system: this.db.system,
      data: { 
        id: eventId, 
        eventText: eventText,
        idBooking: this.booking.id,
        fnamn: this.booking.contact.fnamn,
        enamn: this.booking.contact.enamn,
        workday: this.booking.workday,
        eventTime: now.format('YYYY-MM-DD HH:mm:ss'),
        signature: 'Web',
        system: this.db.system
      },
      id: eventId
    })

  }

  suicide() {
    setTimeout(() => { location.assign(this.dismiss); }, 10 * 1000)
  }

}
